export interface ICharge {
  BillAmount?: any;
  BillingCurrencyCode?: any;
  BillingExchangeRate?: any;
  Code?: any;
  CostCurrencyCode?: any;
  CostExchangeRate?: any;
  CostTaxAmount?: any;
  CostTaxCode?: any;
  CostTaxPercent?: any;
  CostVariance?: any;
  CreatedAt?: any;
  CreatedBy?: any;
  EstimatedCost?: any;
  ExternalRemarks?: any;
  EyeshareCost?: any;
  EyeshareTax?: any;
  Id?: any;
  InternalRemarks?: any;
  IsCharge: true
  IsCostDitributed?: any;
  LocalJobId?: any;
  ModifiedAt?: any;
  ModifiedBy?: any;
  Name?: any;
  OperatingIncomeActual?: any;
  ParentServiceFk?: any
  PaymentTermCode?: any;
  PriceCurrencyCode?: any;
  PriceExchangeRate?: any;
  PriceTaxAmount?: any;
  PriceTaxCode?: any;
  PriceTaxPercent?: any;
  Quantity?: number;
  SupplierCode?: any;
  SupplierName?: any;
  TotalEstimatedCost?: any;
  TotalEyeshareAmount?: any;
  TotalPriceAmount?: any;
  UnitCost?: any;
  UnitPrice?: any;
  UomCode?: any;
  UomName?: any;
  MasterCode?: any;
}
export class Charge implements ICharge {
  BillAmount?: any;

  BillingCurrencyCode?: any;

  BillingExchangeRate?: any;

  Code?: any;

  CostCurrencyCode?: any;

  CostExchangeRate?: any;

  CostTaxAmount?: any;

  CostTaxCode?: any;

  CostTaxPercent?: any;

  CostVariance?: any;

  CreatedAt?: any;

  CreatedBy?: any;

  EstimatedCost?: any;

  ExternalRemarks?: any;

  EyeshareCost?: any;

  EyeshareTax?: any;

  Id?: any;

  InternalRemarks?: any;

  IsCharge: true;

  IsCostDitributed?: any;

  LocalJobId?: any;

  ModifiedAt?: any;

  ModifiedBy?: any;

  Name?: any;

  OperatingIncomeActual?: any;

  ParentServiceFk?: any;

  PaymentTermCode?: any;

  PriceCurrencyCode?: any;

  PriceExchangeRate?: any;

  PriceTaxAmount?: any;

  PriceTaxCode?: any;

  PriceTaxPercent?: any;

  Quantity?: number;

  QuotationNumber?: any;

  SupplierCode?: any;

  SupplierName?: any;

  TotalEstimatedCost?: any;

  TotalEyeshareAmount?: any;

  TotalPriceAmount?: any;

  UnitCost?: any;

  UnitPrice?: any;

  UomCode?: any;

  UomName?: any;

  rowId?: any;

  MasterCode?: any;

  constructor() {
    this.BillAmount = "";
    this.BillingCurrencyCode = "";
    this.BillingExchangeRate = "";
    this.Code = "";
    this.CostCurrencyCode = "";
    this.CostExchangeRate = "";
    this.CostTaxAmount = "";
    this.CostTaxCode = "";
    this.CostTaxPercent = "";
    this.CostVariance = "";
    this.CreatedAt = "";
    this.CreatedBy = "";
    this.EstimatedCost = "";
    this.ExternalRemarks = "";
    this.EyeshareCost = "";
    this.EyeshareTax = "";
    this.Id = 0;
    this.InternalRemarks = "";
    this.IsCharge = true;
    this.IsCostDitributed = "";
    this.LocalJobId = "";
    this.ModifiedAt = "";
    this.ModifiedBy = "";
    this.Name = "";
    this.OperatingIncomeActual = "";
    this.ParentServiceFk = "";
    this.PaymentTermCode = "";
    this.PriceCurrencyCode = "";
    this.PriceExchangeRate = "";
    this.PriceTaxAmount = "";
    this.PriceTaxCode = "";
    this.PriceTaxPercent = "";
    this.Quantity = undefined;
    this.QuotationNumber = "";
    this.SupplierCode = "";
    this.SupplierName = "";
    this.TotalEstimatedCost = "";
    this.TotalEyeshareAmount = "";
    this.TotalPriceAmount = "";
    this.UnitCost = "";
    this.UnitPrice = "";
    this.UomCode = "";
    this.UomName = "";
    this.rowId = 0;
    this.MasterCode = null;
  }
}